import React from 'react';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import { SideSpacer } from '../../components/common/Spacer';
import MemberDingoLabsContainer from '../../containers/member/MemberDingoLabsContainer';
import {
  HorizonWrapper,
  CommonContainer,
} from '../../components/common/Container';

const MemberDingoLabsPage = () => {
    
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <HorizonWrapper>
          <CommonContainer>
            <MemberDingoLabsContainer />
          </CommonContainer>
        </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default MemberDingoLabsPage;
